// extracted by mini-css-extract-plugin
export default {"container":"kvpb77yvYN_rWv1WqfwQ","titleBlock":"xxLvcMJ2kFGMDKLNKshp","icon":"ipzbhn6VXrZXPZQwXyUV"};